module.exports = __webpack_public_path__ + "static/img/modelProcessApp.a5bab879.png";